import { ApiError } from '../api/client';

/**
 * Surfaces the request ID on server faults. A 500 body deliberately carries nothing else — the real
 * message, which can name an orphaned Cognito client, stays in CloudWatch — so the ID is the only
 * thing that connects what the user saw to what an operator can find.
 */
export function ErrorBanner({ error }: { error: unknown }) {
  if (!error) return null;

  const message = error instanceof Error ? error.message : String(error);
  const requestId = error instanceof ApiError ? error.requestId : undefined;

  return (
    <div className="callout callout-error" role="alert">
      <div>{message}</div>
      {requestId && (
        <div className="muted small">
          Request ID <code>{requestId}</code> — quote this to an operator.
        </div>
      )}
    </div>
  );
}
